import React, { PureComponent } from 'react';
import { Route, Switch } from 'react-router-dom';

import Sale from './sale';
import SaleData from './sale-data';
import Stock from './stock';

export default class Report extends PureComponent {
  render() {
    return (
      <Switch>
        <Route component={Sale} exact path={`${this.props.match?.path}/sale`} />
        <Route
          component={SaleData}
          exact
          path={`${this.props.match?.path}/sale-data`}
        />
        <Route
          component={Stock}
          exact
          path={`${this.props.match?.path}/stock`}
        />
      </Switch>
    );
  }
}
